import { render, staticRenderFns } from "./Lives.vue?vue&type=template&id=39294fb1&scoped=true&"
import script from "./Lives.vue?vue&type=script&lang=js&"
export * from "./Lives.vue?vue&type=script&lang=js&"
import style0 from "./Lives.vue?vue&type=style&index=0&id=39294fb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39294fb1",
  null
  
)

export default component.exports